const Events = require('../events/index');
const Core = require('../core');
const { getUserObject } = require('../services/userService');

function getProfile(user) {
    const metadata = {
        ...getUserObject(user)
    };

    Core.trackEvent(Events.USER.GET_PROFILE, metadata);
}

function loginClicked(user) {
    const metadata = {
        ...getUserObject(user)
    };

    Core.trackElalEvent(Events.USER.LOGIN_CLICKED, metadata);
}

function userDataUpdated(user, { points_balance } = {}) {
    const metadata = {
        ...getUserObject(user),
        logged_in: !!(user && user.isLoggedIn),
        ...(Number.isFinite(points_balance) && { points_balance })
    };

    Core.trackEventToProviders(Core.GA4_PROVIDER_NAMES, Events.USER.USER_DATA_UPDATED, metadata);
}

module.exports = {
    getProfile,
    loginClicked,
    userDataUpdated
};
